import api from './interceptor'
import apiEW from './interceptorEW'

// 获取购物车列表数据
export const getShoppingList = () => {
  // replace with aggregator api since EW is included
  // return api.get('/cart/infoDetail/getCartInfoList', { params })
  return apiEW.get('/occ/order/as/aggregator/client/v1/mall/cart/items')
}

// 删除购物车某条数据
export const deleteShoppingInf = params => {
  return api.post('/cart/infoDetail/delete', params)
}

// 删除购物车延保数据
export const deleteEWShopping = params => {
  return apiEW.delete('/occ/order/as/ew/client/v1/cart', { params })
}

// 修改购物车某条数据
export const updateShoppingInf = params => {
  return api.post('/cart/infoDetail/update', params)
}

// 插入购物车
export const addShoppingCar = params => {
  return api.post('/cart/infoDetail/add', params)
}

// 获取轮胎可用优惠券列表
export const getTyreCouponList = params => {
  return api.get('/rightCoupon/tyreCouponList', { params })
}
// 获取购物车数量
export const getCountOfShoppingCar = () => {
  // replace with aggregator api since EW is included
  // return api.get('/cart/infoDetail/countByType', { params })
  return apiEW.get('/occ/order/as/aggregator/client/v1/mall/cart/items/count')
}

// 延保加入购物车
export const addEWShoppingCar = params => {
  return apiEW.post('/occ/order/as/ew/client/v1/cart', params)
}
